export enum KeyboardKeyType {
  None,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowDown,
  Space,
  Escape,
}
